__turbopack_context__.v({
  "recommendation-card": "TaGUNW_recommendation-card",
  "recommendation-card-description": "TaGUNW_recommendation-card-description",
  "recommendation-card-description--secondary": "TaGUNW_recommendation-card-description--secondary",
  "recommendation-card__additional-details": "TaGUNW_recommendation-card__additional-details",
  "recommendation-card__additional-details-icon": "TaGUNW_recommendation-card__additional-details-icon",
  "recommendation-card__additional-details-text": "TaGUNW_recommendation-card__additional-details-text",
  "recommendation-card__close-button": "TaGUNW_recommendation-card__close-button",
  "recommendation-card__content": "TaGUNW_recommendation-card__content",
  "recommendation-card__loader-container": "TaGUNW_recommendation-card__loader-container",
  "recommendation-card__thumbnail": "TaGUNW_recommendation-card__thumbnail",
  "recommendation-card__title": "TaGUNW_recommendation-card__title",
});
